import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';

import { SportCarouselProps } from 'features/sport/components/sportCarousel/types';
import { Swiper } from 'swiper/react';
import { Wrapper } from 'components/wrapper';
import { breakpoint } from 'utility/constant';
import classNames from 'classnames';
import styles from './SportCarousel.module.scss';
import { useHideNavigationCarousel } from 'hooks/useHideNavigationCarousel';
import { useRef } from 'react';

export const SportCarousel = ({ ...props }: SportCarouselProps) => {
  const swiperRef = useRef<any>(null);
  const { isScrollable } = useHideNavigationCarousel({ className: 'disabled', sliderRef: swiperRef });

  return (
    <Wrapper
      noPaddingLeft={props.hasNoLeftPadding}
      noPaddingRight={props.hasNoPaddingRight}
      noPaddingBottom={props.hasNoBottomPadding}
      noPaddingTop={props.hasNoTopPadding}
      bgColorTransparent
      className={props.classNameWrapper}
    >
      {props.title && <h2 className={classNames(styles.title, props.classNameTitle)}>{props.title}</h2>}
      {props.subtitle && <p className={classNames(styles.subtitle, props.classNameTitle)}>{props.subtitle}</p>}
      <div className={classNames(styles.container, styles[props.className])}>
        <Swiper
          onInit={props.onInit}
          spaceBetween={10}
          grabCursor
          slidesPerView={'auto'}
          slidesOffsetBefore={!!props.translateElement?.length ? props.translateElement[0] : 0}
          slidesOffsetAfter={20}
          modules={[Navigation, FreeMode, Mousewheel]}
          updateOnWindowResize
          watchOverflow
          freeMode={{
            enabled: true,
            minimumVelocity: 0.2,
          }}
          mousewheel={{ forceToAxis: true }}
          navigation={!!isScrollable ?? props.navigation}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            [breakpoint.sm]: {
              slidesOffsetBefore: +`${
                !!props.translateElement && props.translateElement?.length > 0 ? props.translateElement[1] : 0
              }`,
              slidesOffsetAfter: 32,
            },
            [breakpoint.lg]: {
              grabCursor: false,
              spaceBetween: 24,
              slidesOffsetBefore: +`${
                !!props.translateElement && props.translateElement?.length > 0 ? props.translateElement[2] : 0
              }`,
              slidesOffsetAfter: 40,
              simulateTouch: false,
              allowTouchMove: false,
            },
          }}
        >
          {props.children}
        </Swiper>
      </div>
    </Wrapper>
  );
};
